module.exports = __webpack_public_path__ + "static/img/02.cf2e1e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/02.png
// module id = 8+q6
// module chunks = 0